import { c, classy } from '@onfido/castor';
import { Icon } from '@onfido/castor-react';
import React from 'react';
export const MaybeIcon = ({ icon, name }) => icon ? (React.createElement("div", { className: classy(c('icon')) }, icon)) : (React.createElement(Icon, { name: name, "aria-hidden": "true" }));
//# sourceMappingURL=maybe-icon.js.map